import GameObject from '../../../GameObject/GameObject';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import GoldCard from '../../../Prototype/Level/Card/GoldCard';
import CardStateHelper from '../../../State/Card/CardStateHelper';
import CardSystem from '../CardSystem';
import ValueCardHandler from './ValueCardHandler';
import { ICardsState } from '../../../State/Card/ICardState';

export default class GoldCardHandler extends ValueCardHandler {
    private goldCard: GoldCard;
    private goldContainer: GameObject;

    constructor(card: BaseCard) {
        super(card);
        this.goldCard = <GoldCard>card;

        const animationContainer = this.card.getChildByName(
            'animationContainer'
        );
        this.goldContainer = animationContainer.getChildByName('goldContainer');
    }

    public handleCardInPlay(state: ICardsState, cardSystem: CardSystem) {
        super.handleCardInPlay(state, cardSystem);

        const cardBehavior = CardStateHelper.getCardBehavior(
            state,
            this.card.id
        );
        const isBlocked = cardBehavior.isBlocked(state);

        // When card is first unblocked
        if (isBlocked !== this.goldCard.isBlocked) {
        }

        this.goldCard.isBlocked = isBlocked;
    }
}
